"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssetIcon = void 0;
var _react = _interopRequireDefault(require("react"));
var _StyledFileTreeItemComponents = require("../styled/StyledFileTreeItemComponents");
/**
 * A function that retrieves the asset icon value, with certain conditions:
 * - some asset types never show simple icons
 * - parents, hovered items, active items, open items, and all items when variant === 'selectable' will show detailed icons
 * - default variant shows simple icons otherwise
 * - custom assetTypes should follow similar calculations so variants work out of the box even with custom icons/colors, etc.
 */
const getAssetIcon = _ref => {
  let {
    isParent,
    isActive,
    isOpen,
    isHovered,
    assetType,
    variant,
    iconVariantMap
  } = _ref;
  const showDetailedIcon = isParent || isActive || isOpen || isHovered || assetType === "folder" || assetType === "collection" || assetType === "content-library" || assetType === "file";
  if (variant === "default") {
    //handle custom asset types
    if (typeof assetType === "object") {
      return showDetailedIcon ? assetType.icon : /*#__PURE__*/_react.default.createElement(_StyledFileTreeItemComponents.StyledSimpleIcon, {
        color: assetType.color,
        "aria-hidden": "true"
      });
    } else {
      //handle predefined assetType string
      return showDetailedIcon ? iconVariantMap[assetType].icon : /*#__PURE__*/_react.default.createElement(_StyledFileTreeItemComponents.StyledSimpleIcon, {
        color: iconVariantMap[assetType].color,
        "aria-hidden": "true"
      });
    }
  }

  // for selectable variants, render detailed icons always, checking for custom assetType icons/colors, etc.
  if (typeof assetType === "object") {
    return assetType.icon;
  } else {
    return iconVariantMap[assetType].icon;
  }
};
exports.getAssetIcon = getAssetIcon;
//# sourceMappingURL=getAssetIcon.js.map